import Details from "./Details";
import Search from "./Search";

export default{
  Details,
  Search
}